import { Reveal } from "./Reveal";
import { SERVICES } from "../../data";
import { ArrowUpRight } from "lucide-react";

const Card = ({ s, i }) => (
  <Reveal
    delay={i * 0.08}
    className={`group relative overflow-hidden border border-hairline bg-surface/30 ${s.span} min-h-[280px] lg:min-h-0`}
  >
    <button
      data-testid={`service-${s.n}`}
      onClick={() => scrollToId("contact")}
      className="absolute inset-0 h-full w-full text-left"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={s.img}
          alt={s.title}
          className="h-full w-full object-cover opacity-25 grayscale group-hover:grayscale-0 group-hover:opacity-40 group-hover:scale-[1.05] transition-[opacity,filter,transform] duration-700 ease-out"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-transparent" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-between p-8 lg:p-10">
        <div className="flex items-center justify-between">
          <span className="font-mono text-xs tracking-[0.25em] text-gold">{s.n}</span>
          <ArrowUpRight size={22} className="text-stone group-hover:text-gold group-hover:rotate-45 transition-transform duration-500" />
        </div>
        <div>
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-stone">{s.tag}</span>
          <h3 className="font-serif font-light text-4xl lg:text-5xl tracking-tight text-parchment mt-2 group-hover:text-gold transition-colors duration-300">{s.title}</h3>
          <p className="text-stone text-sm leading-relaxed mt-4 max-w-md">{s.body}</p>
        </div>
      </div>
    </button>
  </Reveal>
);

export const Services = () => {
  return (
    <section id="services" data-testid="services" className="relative py-28 lg:py-40">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <Reveal className="lg:col-span-7">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">The Platform</span>
            <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-parchment mt-6 text-balance">
              Four mandates.<br />One standard of <span className="italic text-gold">discretion.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5 lg:justify-self-end">
            <p className="text-stone leading-relaxed max-w-md">
              From capital formation to cross-border M&amp;A, every engagement is delivered with institutional rigour and absolute confidentiality.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-7 gap-4 lg:auto-rows-[280px]">
          {SERVICES.map((s, i) => <Card key={s.n} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
